import * as angular from "angular";
import {IController} from "angular";

export class policyViewCtrl implements IController {

  private currentNavItem: any;

  /* @ngInject */
  constructor(private $state) {
  }

  $onInit() {
    this.currentNavItem = this.$state.current.url;
  };

}

angular
  .module('bringoz.admin.policies')
  .component('policyView', {
    template: require('./policy-view.html').default,
    controller: policyViewCtrl
  });
